export const ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT_ROUTE_NAME = Symbol('admin.affiliates.approved.none-negative-carryover.edit-history');
export const TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT = Symbol('admin.affiliates.approved.none-negative-carryover.edit-history');

export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_QUERY = 'affiliate.show-history-none-negative-carryover';
export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_API_URL = 'admin/history_of_nncos_changes/:itemId/edit';

export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_MUTATION = 'affiliate.edit-history-none-negative-carryover';
export const AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_API_URL = 'admin/history_of_nncos_changes/:itemId';
